<template>
  <div style="opsition:absolute;z-index:9999;">
    <!-- 案件备注 -->
    <Modal
      v-model="caseNotesCtrl"
      title="案件备注"
      :width="450"
      :footer-hide="true"
      @on-cancel="cancel"
    >
      <Form
        ref="formValidate" :model="formValidate"
        :rules="ruleValidate" :label-width="80"
      >
        <FormItem label="关注程度" prop="attention">
          <RadioGroup v-model="formValidate.attention">
            <Radio label="N">一般</Radio>
            <Radio label="Y">重要</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="类型" prop="category">
          <RadioGroup v-model="formValidate.category">
            <Radio
              v-for="(item, index) in categoryArr" :key="index"
              :label="item.value"
            >{{ item.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-show="false" label="是否公开"
          prop="isPublic"
        >
          <Select v-model="formValidate.isPublic" placeholder="是否公开">
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="note">
          <Input
            v-model.trim="formValidate.note" type="textarea"
            :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写备注信息(不超过512个字符)"
          />
        </FormItem>
        <FormItem
          v-if="formValidate.category == 'E'" label="附件"
          prop="memoAttachments"
          :rules="[{ required: true, type:'array', message: '附件不能为空', trigger: 'blur' }]"
        >
          <file-upload :default-list="formValidate.memoAttachments " @getFileList="getAttachmentList" />
        </FormItem>
      </Form>
      <Row v-if="noteList.length>4">
        <Scroll :on-reach-bottom="handleReachBottom">
          <Timeline style="margin-left:10px;">
            <TimelineItem v-for="(item, index) in noteList" :key="index">
              <Icon
                slot="dot" type="ios-radio-button-on"
                :size="18" :color="styles.globalMainColor"
              />
              <Row class="line-content">
                <Row class="line-right">
                  <span class="line-name mgr-10 fs-14">{{ item.categoryName }}</span>
                  <span v-if="item.attention =='Y'" class="line-name import-attention fs-16">{{ item.memo }}</span>
                  <span v-if="item.attention =='N'" class="line-name fs-16">{{ item.memo }}</span>
                  <a
                    v-if="item.operatePermission" href="javascript:void(0);"
                    style="padding-left:10px" @click="deleteMemo(item.id)"
                  >删除</a>
                  <div class="line-time">
                    <span v-if="item.category == 'E'">
                      <file-upload :default-list="item.memoAttachments || []" :upload-config="{ readOnly: true }" />
                    </span>
                  </div>
                  <div class="line-time">
                    <span>添加人：{{ item.creatorName }}</span>
                    <span>添加时间：{{ item.createTime }}</span>
                  </div>
                </Row>
              </Row>
            </TimelineItem>
          </Timeline>
        </Scroll>
      </Row>
      <Row v-else>
        <Timeline style="margin-left:10px;">
          <TimelineItem v-for="(item, index) in noteList" :key="index">
            <Icon
              slot="dot" type="ios-radio-button-on"
              :size="18" :color="styles.globalMainColor"
            />
            <Row class="line-content">
              <Row class="line-right">
                <span class="line-name mgl-10 fs-14">{{ item.categoryName + ':' }}</span>
                <span v-if="item.attention =='Y'" class="line-name import-attention fs-16">{{ item.memo }}</span>
                <span v-if="item.attention =='N'" class="line-name fs-16">{{ item.memo }}</span>
                <a
                  v-if="item.operatePermission" href="javascript:void(0);"
                  style="padding-left:10px" @click="deleteMemo(item.id)"
                >删除</a>
                <div class="line-time">
                  <span v-if="item.category == 'E'">
                    <file-upload :default-list="item.memoAttachments || []" :upload-config="{ readOnly: true }" />
                  </span>
                </div>
                <div class="line-time">
                  <span>添加人：{{ item.creatorName }}</span>
                  <span>添加时间：{{ item.createTime }}</span>
                </div>
              </Row>
            </Row>
          </TimelineItem>
        </Timeline>
      </Row>
      <Row style="text-align:center;margin-top:10px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="caseNoteSubmit('formValidate')"
        >确认</Button>
        <Button style="margin-left: 8px" @click="cancel">取消</Button>
      </Row>
    </Modal>

    <!-- 分配 -->
    <Modal
      v-model="confirmCtrl"
      title="案件分配"
      :width="360"
      :footer-hide="true"
    >
      <Form
        ref="formItem" :model="formItem"
        :label-width="80"
      >
        <FormItem
          label="负责人" prop="accepter"
          :rules="{required: true, type:'array',message: '请选择负责人', trigger: 'blur'}"
        >
          <mySelect
            ref="accepterSelect"
            :path="'/base/lawyers'"
            type="multiple"
            :placeholder="'请选择负责人'"
            :placeholder-input="'请输入负责人'"
            :default-obj="selectedReportUser"
            :key-name="'name'"
            @getValue="getMemberId"
          />
        </FormItem>
      </Form>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="allocationSubmit('formItem')"
        >确认</Button>
        <Button style="margin-left: 8px" @click="confirmCtrl=false;">取消</Button>
      </Row>
    </Modal>

    <!-- 终止 -->
    <Modal
      v-model="stopApplyCtrl"
      title="申请终止"
      :width="360"
      :footer-hide="true"
    >
      <Form
        ref="formValidateStopCase" :model="formValidateStopCase"
        :label-width="80"
      >
        <Row>
          <FormItem
            label="终止原因"
            prop="applicationReason"
            :rules="{required: true, type:'array', message: '请选择终止原因', trigger: 'change'}"
          >
            <Select
              v-model="formValidateStopCase.applicationReason" placeholder="请选择终止原因"
              multiple
            >
              <Option
                v-for="item in stopReasonArr" :key="item.nameZh"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="stopApplyCtrl"
            label="终止凭证"
            prop="terminationAttachments"
            :rules="{ required: true,type:'array', message: '终止凭证附件不能为空', trigger: 'change' }"
          >
            <file-upload
              :upload-config="{}"
              @getFileList="getTerminationAttachmentList"
            />
          </FormItem>
          <FormItem
            label="终止备注"
            prop="applicationNote"
            :rules="[{required: true, message: '请填写终止备注', trigger: 'blur'},{ max:200,message:'不能超过200个字符',trigger:'blur'}]"
          >
            <Input
              v-model.trim="formValidateStopCase.applicationNote" type="textarea"
              :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写备注信息(不超过200个字符)"
            />
          </FormItem>
        </Row>
      </Form>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="agreeSubmit"
        >确认</Button>
        <Button style="margin-left: 8px" @click="stopApplyCtrl=false;">取消</Button>
      </Row>
    </Modal>

    <!-- 查看终止申请驳回原因 -->
    <Modal
      v-model="rejectReasonCtrl"
      title="驳回原因"
      :width="360"
      :footer-hide="true"
    >
      {{ rejectReason }}
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button type="primary" @click="rejectReasonCtrl=false;">确认</Button>
      </Row>
    </Modal>

    <!-- 删除备注确认-->
    <Modal
      v-model="deleteMomeCtrl"
      title="删除确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">请问是否删除此记录？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="isDeleteFn"
        >确认</Button>
        <Button style="margin-left: 8px" @click="deleteMomeCtrl=false;">取消</Button>
      </Row>
    </Modal>

    <!-- 案件类型转换 -->
    <Modal
      v-model="changeCaseTypeCtrl"
      :title="'案件类型转换'"
      :width="450"
      :footer-hide="true"
      @on-visible-change="formDataChangeCaseType.caseCategory = '';formDataChangeCaseType.seriousType = '';"
    >
      <Form
        ref="formDataChangeCaseType"
        :model="formDataChangeCaseType" :label-width="100"
      >
        <FormItem
          label="案件类型" prop="caseCategory"
          :rules="[{required:true,type:'string', message:'请选择转案类型',trigger:'change'}]"
        >
          <RadioGroup v-model="formDataChangeCaseType.caseCategory">
            <Radio v-if="caseDetail && caseDetail.caseCategory!='E'" label="E">补证案件</Radio>
            <Radio v-if="caseDetail && caseDetail.caseCategory!='I'" label="I">重案案件</Radio>
            <Radio v-if="caseDetail && caseDetail.caseCategory!='N'" label="N">普通案件</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="formDataChangeCaseType.caseCategory==='I'" label="重案原因"
          prop="seriousType"
          :rules="[{required:true,type:'string', message:'请选择重案原因',trigger:'change'}]"
        >
          <Select
            v-model="formDataChangeCaseType.seriousType" placeholder="请选择转重案原因"
            @on-change="seriousTypeChange"
          >
            <Option
              v-for="item in seriousReasonArr" :key="item.value"
              :value="item.value"
            >
              {{ item.nameZh }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="formDataChangeCaseType.seriousType === 'K'"
          label="重案说明"
          :rules="[{required: true, message: '请填写重案说明', trigger: 'blur'},{ max:200,message:'不能超过200个字符',trigger:'blur'}]"
          prop="seriousReason"
        >
          <Input
            v-model.trim="formDataChangeCaseType.seriousReason" type="textarea"
            :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写重案说明"
          />
        </FormItem>
      </Form>

      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="handleSubmit('formDataChangeCaseType')"
        >
          确认
        </Button>
        <Button style="margin-left: 8px" @click="changeCaseTypeCtrl = false;$refs['formDataChangeCaseType'].resetFields()">取消</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {},
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    idList: {
      type: Array,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    auditNote: {
      type: String
    },
    selectedReportUser: {
      type: Array
    },
    isReaload: {
      type: Boolean,
      default: true
    },
    caseDetail: {
      type: [Object, String]
    }
  },
  data () {
    const validateStar = (rule, value, callback) => {
      if (value <= 0) {
        return callback(new Error('请标注关注程度'))
      }
      callback()
    }
    return {
      styles: styles,
      stopReasonArr: [],
      categoryArr: [],
      stopApplyCtrl: false,
      changeCaseTypeCtrl: false,
      isSubmit: false,
      rejectReasonCtrl: false,
      rejectReason: '',
      caseNotesCtrl: false,
      deleteId: '',
      deleteMomeCtrl: false,
      formValidate: {
        attention: 'N', // (N：普通 Y：重要)
        isPublic: '1',
        note: '',
        category: 'N',
        memoAttachments: []
      },
      formDataChangeCaseType: {
        caseCategory: '',
        seriousType: '',
        seriousReason: ''
      },
      seriousReasonArr: [],
      ruleValidate: {
        attention: [{ required: true, message: '请选择', trigger: 'change' }],
        isPublic: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        note: [
          { required: true, message: '请填写备注', trigger: 'blur' },
          { max: 512, message: '不能超过512个字符', trigger: 'blur' }
        ]
      },
      noteList: [], // 备注数据
      formValidateStopCase: {
        applicationNote: '',
        applicationReason: '',
        terminationAttachments: []

      },
      formItem: {
        accepter: []
      },
      confirmCtrl: false,
      table: { // 表格数据接口的相关参数
        pageSize: this.config.modalPageSize,
        pageNum: 1,
        totalRecords: 1
      }
    }
  },
  watch: {
    type(val, oldVal) {
      if (this.type === 'caseNotes') {
        this.$refs['formValidate'].resetFields()
        this.caseNotesCtrl = true
        this.getCaseNotes()
      } else if (this.type === 'terminated') {
        this.$refs['formValidateStopCase'].resetFields()
        this.stopApplyCtrl = true
      } else if (this.type === 'rejectReason') {
        this.rejectReason = this.auditNote
        this.rejectReasonCtrl = true
      } else if (this.type === 'changeCaseType') {
        this.changeCaseTypeCtrl = true
        this.$refs['formDataChangeCaseType'].resetFields()
      } else if (this.type === 'allocation') {
        this.confirmCtrl = true
        this.$refs['formItem'].resetFields()
        this.$refs.accepterSelect.clearSelected()
        this.$nextTick(function() {
          this.$refs.accepterSelect.voluation()
        })
      }
    },
    caseNotesCtrl(val) {
      if (!val) {
        this.$emit('reloadList', false)
      }
    },
    changeCaseTypeCtrl(val) {
      if (!val) {
        this.$emit('reloadList', false)
      }
    },
    stopApplyCtrl(val) {
      if (!val) {
        this.$emit('reloadList', false)
      }
    },
    rejectReasonCtrl(val) {
      if (!val) {
        this.$emit('reloadList', false)
      }
    },
    selectedReportUser: {
      handler() {
        this.getMemberId(this.selectedReportUser)
      },
      deep: true
    },
    confirmCtrl(val) {
      if (!val) {
        this.$emit('reloadList', false)
      }
    }
  },
  created() {},
  beforeMount() {
    this.getDictionary()
  },
  mounted() {
  },
  updated() {},
  methods: {
    // 案件备忘
    caseNoteSubmit(name) {
      const url = '/business/case-memo'
      const ajaxData = {
        caseId: this.id,
        attention: this.formValidate.attention,
        memo: this.formValidate.note,
        isPublic: this.formValidate.isPublic === '1',
        category: this.formValidate.category,
        memoAttachments: this.formValidate.memoAttachments
      }
      if (ajaxData.category != 'E') {
        delete ajaxData.memoAttachments
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          this.$post(url, ajaxData).then(res => {
            this.isSubmit = false
            this.caseNotesCtrl = false
            if (res.code === 0) {
              this.$Message.success('操作成功！')
              this.$emit('reloadList', this.isReaload)
              this.cancel()
            } else {
              this.$Message.error(res.message)
              this.cancel()
            }
          })
        }
      })
    },
    getAttachmentList(arr) {
      this.formValidate.memoAttachments = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.memoAttachments.push(obj)
      })
    },
    // 案件类型转换
    handleSubmit(name) {
      const url = '/business/case/change-case-category'
      this.$refs[name].validate((valid) => {
        if (valid) {
          const ajaxData = {
            caseIds: [this.id],
            ...this.formDataChangeCaseType
          }
          this.isSubmit = true
          this.$post(url, ajaxData).then(res => {
            this.isSubmit = false
            if (res.code == 0) {
              this.$Message.success('操作成功！')
              this.changeCaseTypeCtrl = false
              this.getData()
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    seriousTypeChange(value) {
      if (value !== 'K') {
        this.formDataChangeCaseType.seriousReason = this.seriousReasonArr.find(item => item.value === value).nameZh
      } else {
        this.formDataChangeCaseType.seriousReason = ''
      }
    },
    getTerminationAttachmentList(arr) {
      this.formValidateStopCase.terminationAttachments = []
      arr.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidateStopCase.terminationAttachments.push(obj)
      })
    },
    // 删除备注
    deleteMemo(id) {
      this.deleteId = id
      this.deleteMomeCtrl = true
    },
    // 确认删除备注
    isDeleteFn() {
      const url = `/business/case-memo/${this.deleteId}`
      this.isSubmit = true
      this.$del(url).then(res => {
        this.isSubmit = false
        if (res.code == 0) {
          this.$Message.success('删除成功！')
          this.deleteMomeCtrl = false
          this.$emit('reloadList', this.isReaload)
          this.cancel()
        } else {
          this.$message.error(res.message || '删除失败！')
        }
      })
    },
    // 案件分配
    allocationSubmit(name) {
      const url = '/business/cases/distribution/lawyer'
      const ajaxData = {
        caseIdList: [this.id],
        userId: this.formItem.accepter
      }
      if (this.idList && this.idList.length > 0) {
        ajaxData.caseIdList = this.idList
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          this.$patch(url, ajaxData).then(res => {
            this.isSubmit = false
            this.confirmCtrl = false
            if (res.code == 0) {
              this.$Message.success('操作成功！')
              this.$emit('reloadList', true)
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    // 获取负责人id
    getMemberId(data) {
      this.formItem.accepter = []
      if (data && data.length > 0) {
        this.formItem.accepter = data.map(item => {
          return item.id
        })
      }
    },
    // 案件终止
    agreeSubmit() {
      const url = '/business/case/termination/lawyer'
      const ajaxData = { caseId: this.id }
      Object.assign(ajaxData, this.formValidateStopCase)
      ajaxData.applicationReason = this.formValidateStopCase.applicationReason.toString() || ''
      this.$refs['formValidateStopCase'].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          this.$post(url, ajaxData).then(res => {
            this.isSubmit = false
            this.stopApplyCtrl = false
            if (res.code == 0) {
              this.$Message.success('操作成功！')
              this.$emit('reloadList', true)
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    // 获取备注录
    getCaseNotes() {
      const url = '/business/case-memoes'
      const ajaxData = {
        current: this.table.pageNum,
        size: this.table.pageSize,
        caseId: this.id
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0) {
          this.noteList = this.noteList.concat(res.data.records)
          this.noteList.forEach(item => {
            if (item.createTime) {
              item.createTime = item.createTime.replace('T', ' ')
            }
          })
          // this.table.totalRecords = res.data.total;
        }
      })
    },
    // 滚动加载更多备注记录
    handleReachBottom () {
      return new Promise(resolve => {
        this.table.pageNum = this.table.pageNum + 1
        this.getCaseNotes()
        resolve()
      })
    },
    // 清除备注
    cancel() {
      this.noteList = []
      this.table.pageNum = 1
      this.table.pageSize = 5
      this.caseNotesCtrl = false
    },
    // 获取字典数据接口
    async getDictionary() {
      this.stopReasonArr = await this.common.getDictionaryItems('lawyer_stop_reason')
      this.seriousReasonArr = await this.common.getDictionaryItems('serious_case_reason')
      this.categoryArr = await this.common.getDictionaryItems('case_memo_category')
    }
  }
}
</script>
<style lang="scss" scoped>
.import-attention{
    color: #ff5555
}
.fs-14{
    font-size: 14px;
    font-weight: 700;
}
.fs-16{
    font-size: 16px;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/view/case/plugins/listOptions.vue